import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { createBrowserHistory } from "history";
import { BrowserRouter } from "react-router-dom";

const hist = createBrowserHistory();

const div = document.getElementById("AGMroot") ? "AGMroot" : "root";

console.log(
  'document.getElementById("AGMroot")',
  document.getElementById("AGMroot"),
);

//hide app if div is "AGMroot" and id_oportunity is not in url params
if (
  div === "AGMroot" &&
  !window.location.search.includes("id_oportunity") &&
  !window.location.search.includes("id_opportunity") &&
  !window.location.hostname.includes("localhost")
) {
  document.getElementById(div).style.display = "none";
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter history={hist}>
      <App root={div} />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById(div),
);
